function initTestimonialsCarousel(root) {
  if (!root) return;
 
  const track = root.querySelector('[data-testimonials-track]');
  const wrapper = root.closest('.testimonials-wrapper');
  const dotsContainer = wrapper ? wrapper.querySelector('[data-testimonials-dots]') : null;
 
  if (!track) return;
 
  const cards = Array.from(track.children);
  if (!cards.length) return;
 
  // Build dots
  if (dotsContainer) {
    dotsContainer.innerHTML = '';
    cards.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'testimonials-dot';
      dot.setAttribute('aria-label', 'Go to testimonial ' + (index + 1));
      if (index === 0) dot.setAttribute('aria-current', 'true');
      dot.addEventListener('click', () => {
        cards[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      dotsContainer.appendChild(dot);
    });
  }
 
  function updateActiveDot() {
    if (!dotsContainer) return;
    const trackRect = track.getBoundingClientRect();
    const centerX = trackRect.left + trackRect.width / 2;
 
    let closestIndex = 0;
    let closestDistance = Infinity;
 
    cards.forEach((card, index) => {
      const cardRect = card.getBoundingClientRect();
      const cardCenter = cardRect.left + cardRect.width / 2;
      const distance = Math.abs(cardCenter - centerX);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });
 
    const dots = dotsContainer.querySelectorAll('.testimonials-dot');
    dots.forEach((dot, index) => {
      if (index === closestIndex) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }
 
  let scrollTimeout;
  track.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateActiveDot, 80);
  });
}
 
function initAllTestimonialsCarousels() {
  document.querySelectorAll('[data-testimonials-carousel]').forEach(initTestimonialsCarousel);
}
 
document.addEventListener('DOMContentLoaded', initAllTestimonialsCarousels);
document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('[data-testimonials-carousel]');
  if (root) initTestimonialsCarousel(root);
});